import * as authentication from "../actions/authentication";
import * as systemMessage from "../actions/systemMessage";

import Immutable from "seamless-immutable";

const defaultState = () => Immutable({
    counter: 0,
    messages: [],
});

/**
 * 
 * @param {Object} state 
 * @param {{type: String}} action 
 * @returns {Object}
 */
export default function(state = defaultState(), action) {
    switch (action.type) {
    case systemMessage.PUSH_MESSAGE:
        return state.merge({
            counter: state.counter+1,
            messages: state.messages.concat({
                type:action.messageType,
                message:action.message,
                key: state.counter
            }),
        }, {
            deep: true
        });
    case systemMessage.REMOVE_MESSAGE:
        return Immutable.setIn(state, ["messages"], Immutable(state.messages).filter( (item,index) => index!==action.index));
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}